module.exports = __webpack_public_path__ + "media/images/athletes/2521-3c3df0cbeaee29f196afc339199896d8.png";